var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative cursor-default",
    class: {
      'cursor-pointer': !_vm.disabled_pass && !_vm.disabled,
      'disabled || disabled_pass': _vm.disabled_pass || _vm.disabled,
      'pt-2.5': _vm.alignWithoutLibelle != null && _vm.alignWithoutLibelle,
      'xl:pt-7 xxl:pt-8 2xl:pt-10': _vm.alignWithoutLibelle == null || !_vm.alignWithoutLibelle
    },
    on: {
      "click": _vm.activeCheckbox,
      "mouseover": function ($event) {
        _vm.tooltip = true;
      },
      "mouseleave": function ($event) {
        _vm.tooltip = false;
      }
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "duration-300 delay-1000",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.tooltip && _vm.label != null ? _c('div', {
    staticClass: "absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 right-10 z-30 p-2 text-sm w-max-content w-max max-w-128"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "rounded-md border-2 border-pink-300 text-center text-sm transition-all duration-200 px-3 py-2.5 xxl:px-3.5 xxl:py-3 2xl:px-4 2xl:py-3.5",
    class: {
      'text-white bg-pink-600': _vm.mutableValue,
      'bg-pink-100 text-gray-900': !_vm.mutableValue
    }
  }, [_vm._v("\n    " + _vm._s(_vm.libelle) + "\n  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutableValue,
      expression: "mutableValue"
    }],
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.mutableValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.mutableValue = $event.target.value;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }